"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inactiveStyles = exports.defaultStyles = exports.buttonGroupStyles = exports.activeStyles = void 0;
const defaultStyles = exports.defaultStyles = {
  border: 0,
  borderRadius: '4px',
  fontWeight: 'normal',
  paddingX: 4,
  paddingY: 1,
  _hover: {
    boxShadow: '0 0 0 2px rgba(158, 202, 237, 1)'
  },
  _focus: {
    boxShadow: '0 0 0 2px rgba(158, 202, 237, 1)'
  }
};
const inactiveStyles = exports.inactiveStyles = {
  color: 'black',
  borderColor: 'gray.100',
  bg: 'gray.100',
  _hover: {
    bg: 'gray.100'
  },
  _active: {
    bg: 'gray.100'
  }
};
const activeStyles = exports.activeStyles = {
  color: 'black',
  fontWeight: 'semibold',
  boxShadow: 'sm',
  bg: 'white',
  _hover: {
    bg: 'white'
  },
  _active: {
    bg: 'white'
  }
};
const buttonGroupStyles = exports.buttonGroupStyles = {
  borderRadius: '4px',
  backgroundColor: 'gray.100',
  padding: 1
};